import * as React from 'react';
var RouletteContext = React.createContext({});
export var Provider = RouletteContext.Provider, Consumer = RouletteContext.Consumer;
export default RouletteContext;
//# sourceMappingURL=RouletteContext.js.map